import {getStableTabId} from '@aboutyou/utils';

export const SSO_CALLBACK_ROUTE = '/__/sso_callback';

export const SSO_CALLBACK_EVENT = 'SSO_CALLBACK_EVENT';

export const getSSOChannel = () => {
  return `SSO_CHANNEL_${getStableTabId()}`;
};
